import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges Tailwind CSS class names with proper conflict resolution.
 * Combines clsx (conditional classes) with tailwind-merge (deduplication).
 *
 * @param  {...(string|object|array)} inputs - Class names or conditional objects
 * @returns {string} Merged class string
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-primary', className)
 * cn('text-sm text-red-500', 'text-blue-500') // → 'text-sm text-blue-500'
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
